import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
// Utils
import { replaceLineBreakShortCode } from '../../utils/replace-shortcode-br';
// Styles
import { Container, ContentSemi } from '../styled/containers';
import { VisuallyHidden } from '../styled/accessibility';
import Button from '../button';
import {
  Banner,
  Wrapper,
  Header,
  SubText,
  StyledDonationFormHandler,
} from './styles';
// Components
import DonationInput from '../form-elements/donation-input';

const DonationBanner = ({
  headerText,
  secondaryText,
  defaultDonationValue,
  borderTop,
  removeMarginBottom,
}) => (
  <Banner $removeMarginBottom={removeMarginBottom} $borderTop={borderTop}>
    <Container>
      <Wrapper>
        <ContentSemi>
          <Header>{replaceLineBreakShortCode(headerText)}</Header>
        </ContentSemi>
        <ContentSemi>
          {secondaryText && <SubText>{secondaryText}</SubText>}
          <StyledDonationFormHandler
            defaultDonationValue={defaultDonationValue || undefined}
            render={({ defaultValue, values }) => (
              <>
                <VisuallyHidden as="label" htmlFor="amount-holder">
                  {`Donate amount, suggest £${
                    values['amount-holder'] || defaultValue
                  }`}
                </VisuallyHidden>
                <Field name="amount-holder">
                  {({ meta, ...rest }) => (
                    <DonationInput
                      noMargin
                      inline
                      placeholder={defaultValue.toString()}
                      {...rest}
                      id="amount-holder"
                    />
                  )}
                </Field>
                <Button bg="primary" type="submit">
                  Donate now
                </Button>
              </>
            )}
          />
        </ContentSemi>
      </Wrapper>
    </Container>
  </Banner>
);
DonationBanner.propTypes = {
  headerText: PropTypes.string.isRequired,
  secondaryText: PropTypes.string,
  defaultDonationValue: PropTypes.number,
  borderTop: PropTypes.bool,
  removeMarginBottom: PropTypes.bool,
};

export default DonationBanner;

export const DonationBannerAssembly = ({ contentfulData }) => (
  <DonationBanner
    headerText={contentfulData.headerText}
    secondaryText={contentfulData.secondaryText}
    defaultDonationValue={contentfulData.donationInputDefaultValue}
    borderTop={contentfulData.borderTop ?? false}
    removeMarginBottom={contentfulData.removeMarginBottom}
  />
);

DonationBannerAssembly.propTypes = {
  contentfulData: PropTypes.object,
};
